import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=2759e08e"
import script from "./ios.vue?vue&type=script&lang=js"
export * from "./ios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports